const themeColors = {
  colorPrimary: "#00296A",
  colorSecondary: "#3b62a0",
  colorTertiary: "#D9C99E",
  colorAccent: "#11243E",
  colorShad: "#42454A",
  colorAlt: "#00296A",
  white: "rgba(255,255,255, 1)",
  grey: "rgba(226,232,233, 1)",
  greyMed: "rgba(120,119,124, 1)",
  greyBrownish: "#707070",
  greyBrown: "rgba(67,67,67, 1)",
  black: "rgba(0,0,0, 1)",
  strongred: "rgba(255, 0, 0, 1)",
}

export default themeColors
